import React from 'react';

const curriculumContext = React.createContext(null);

export default curriculumContext;
